import React from "react"
import { Messages } from "@sogei/react-web-components-catalog"
function NotFound() {
    return (
        <div className="main-min-vh" role="main">
            <div className="container-fluid py-3 py-md-4">
                <Messages
                    successMessages={[]}
                    infoMessages={[]}
                    warningMessages={[]}
                    dangerMessages={[
                        { text: "Attenzione, pagina non trovata." }
                    ]}
                ></Messages>
                {/* <div className="row">
                    <div className="col">
                        <div className="alert alert-danger d-flex" role="alert">
                            <p className="alert-content">Attenzione, pagina non trovata.</p>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )
}
export default NotFound
